import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async get ({ state, commit, dispatch }) {
    try {
      const { data } = await directus.getItems('member_seating_status', {
        filter: {
          user: {
            eq: state.userId
          }
        }
      })

      if (data.length === 0) return true

      commit('setAttr', {
        name: 'model',
        value: data[0]
      })
      dispatch('set')

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
